import type { GetTweets200Page } from './getTweets200Page';

export type GetTweets200 = {
  code?: string;
  message?: string;
  page?: GetTweets200Page;
  success?: boolean;
};
